import { LightMode, DarkModeRounded } from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';
import { t } from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import Data from "../Data/.json"
import GetCookie from '../Services/GetCookie';
import SetCookie from '../Services/SetCookie';

const Mode = () => {

    const cookieMode = GetCookie(Data.mode);
    const [mode, setmode] = React.useState(cookieMode ? cookieMode : () => {
        SetCookie(Data.mode, 'sys')
        return "sys"
    })
    const { t, i18n } = useTranslation();


    function SetCookieMode() {
        SetCookie(Data.mode, ((mode == "light") ? "dark" : "light"))
        setmode((mode == "light") ? "dark" : "light")
        window.location.reload()
    }


    return (
        <Tooltip title={(mode == "light") ? (t('mode-sombre')) : (t('mode-claire'))}>
            <IconButton
                onClick={SetCookieMode}
                size="large"
                aria-label="display more actions"
                edge="end"
                color={"primary"}
            >
                {(mode == "light") ? <LightMode /> : <DarkModeRounded />}
            </IconButton>
        </Tooltip>
    );
};

export default Mode;